import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 1a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0V4h1a1 1 0 1 0 0-2h-1zM4.327 5.26A1 1 0 0 1 5 5h8c.828 0 1.484.407 1.875.72a4.3 4.3 0 0 1 .654.652l.013.017.004.006.002.003.002.002 2.01 2.68 4.604.767h.004l.005.001.01.002.024.005a2 2 0 0 1 .265.071c.154.051.365.138.583.284.463.309.945.885.945 1.79v3a1 1 0 0 1-1 1h-2.17a3.001 3.001 0 0 1-5.66 0H7.83a3.001 3.001 0 0 1-5.66 0H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 .005-.1v-.003l.001-.007.002-.022a8 8 0 0 1 .046-.353c.033-.235.086-.565.165-.961.158-.787.423-1.85.853-2.925.462-1.157 1.3-2.258 1.972-3.034a19 19 0 0 1 1.25-1.305l.023-.02.007-.007.002-.002zM22 14h-1.17a3.001 3.001 0 0 0-5.66 0H7.83a3.001 3.001 0 0 0-5.66 0h-.163l.027-.202c.029-.203.076-.498.147-.852.142-.713.377-1.65.747-2.575.338-.843 1-1.742 1.628-2.466.306-.353.589-.648.795-.854L5.402 7H13c.172 0 .39.093.625.28a2.3 2.3 0 0 1 .318.312l.01.013L16.2 10.6a1 1 0 0 0 .636.386l4.98.83.008.003.016.005a.5.5 0 0 1 .105.05c.03.02.04.033.041.036q.002 0 .006.016.006.014.008.074zM4 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0m13 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }